import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class RolesService {

    constructor(private http : HttpClient) { }

    private BASE_URL = environment.apiURL;
    private OPTIONS = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json; charset=UTF-8'
        })
    }

    loadRoles(){
        let url = this.BASE_URL + "roles/list"
        return this.http.get(url, this.OPTIONS)
    }

    listElements(){
      let url = this.BASE_URL + "roles/listElements"
      return this.http.get(url, this.OPTIONS)
    }

    createRole(body : any){
      let url = this.BASE_URL + "roles"
      return this.http.post(url, body, this.OPTIONS)
    }

    getRole(){
      let url = this.BASE_URL + "roles/getRole"
      return this.http.get(url,this.OPTIONS)
    }

    listDetails(uuid : any){
      let url = this.BASE_URL + "roles/listDetails?uuid=" + uuid
      return this.http.get(url, this.OPTIONS)
    }

    updateRole(body : any){
      let url = this.BASE_URL + "roles/update"
      return this.http.post(url, body, this.OPTIONS)
    }
}
